
const data = {
  siteConfiguration: {
    siteTitle: 'The Pulse',
    logo: {
      url: 'https://images.ctfassets.net/q5l7sv7fkjc7/4ONvr0PdTzx6LeG8ty9jDC/48a83ec6c98137b24b7615a144a3e693/logo-dark.svg',
      title: 'UTA Logo',
      width: 71,
      height: 76,
    },
    primaryNavigationCollection: {
      items: [
        {
          sys: {
            id: '7r3wtA3IbN9TubzHDoIlsf',
          },
          label: 'HOME',
          url: '/',
        },
        {
          sys: {
            id: '7u34XJn8pTsJSI5VjKLWGN',
          },
          label: 'APPLICATIONS',
          url: '/',
        },
        {
          sys: {
            id: '5AFnv5mTtmNVYZ2LXsOAOj',
          },
          label: 'PLAYBOOKS',
          url: '/',
        },
        {
          sys: {
            id: '4bkx1nNSS04FIu8lYvK3nM',
          },
          label: 'COMPANY SERVICES',
          url: '/',
        },
        {
          sys: {
            id: '4bkx1nNSS04FIu8lYvK3nJ',
          },
          label: 'NEWSLETTERS',
          url: '/',
        },
      ],
    },
    footerNavigationCollection: {
      items: [],
    },
  },
  pageTemplateStandardCollection: {
    items: [],
  },
  expansionHamburgerCollection: {
    items: [],
  },
  uiTextCollection: {
    items: []
  },
}

export default data
